import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button } from "reactstrap";
import Proptypes from "prop-types";
import ServiceBotSubscription from "../../../components/ServiceBot/Subscription/Subscription.js";
import ServiceBotSignup from "../../../components/ServiceBot/Signup/Signup.js";
import { getUser, getAllProducts, getSubscriptionInfo } from "../../../actions/actionUser";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { getNewToken } from "../../../actions/actionLogin";


class UserSubscription extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleResponse = this.handleResponse.bind(this);
        this.refreshToken = this.refreshToken.bind(this)
    }

    async componentDidMount() {

        this.props.getSubscriptionInfo()
        const user = await this.props.getUser()
        if (user && user.response) {
            this.setState({ user: user.response.user });
        }

        const products = await this.props.getAllProducts()
        if (products && products.response && products.response.length > 0) {
            this.setState({ has_products: true });
        }

    }



    refreshToken() {
        const userInfo = JSON.parse(window.localStorage.getItem("user_info"));
        const payload_data = {
            token: userInfo.token,
            username: userInfo.username,
        };
        this.props.getNewToken(payload_data).then((res) => {
            window.location.href = "/"
        });

    }
    handleResponse(payload) {
        if (payload.event && payload.event === "create_subscription" || payload.event && payload.event === "change_plan") {
            setTimeout(() => {
                this.refreshToken();
            }, 3000);
        }
    }

    render() {
        if (this.props.getUsersLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const { user } = this.state;
        const { subSummary, subInfoLoading } = this.props
        const bgImage = () => {
            let launcher_background_url = window.localStorage.getItem("launcher_background_url");
            let bgimage = '/img/backgrounds/background1.jpg'
            if (launcher_background_url && launcher_background_url !== 'undefined') {
                bgimage = launcher_background_url
            }

            return bgimage;
        }


        return (
            <Row>
                <div className={'panelbackground'} style={{ backgroundImage: "url(" + bgImage() + ")" }}>

                    <div style={{ width: '100%', padding: '50px' }}>

                        <Col sm={{ size: 8, order: 3, offset: 2 }} className="tw-text-center">
                            {user && !user.program_id && this.state.has_products ?
                                <Card style={{ backgroundColor: 'var(--modal-bg)' }}>
                                    <CardBody className="user-setting tw-text-left">
                                        <ServiceBotSubscription
                                            email={user.username}
                                            hash={user.hash}
                                            handleResponse={this.handleResponse}
                                        />
                                    </CardBody>
                                </Card>

                                :
                                ""
                            }
                        </Col>
                    </div>
                </div>

            </Row>
        );
    }
}

UserSubscription.propTypes = {
};

export default connect(state =>
({
    user: state.user.user || [],
    createSub: state.user.createSub,
    subSummary: state.user.subSummary,
    subInfoLoading: state.user.subInfoLoading,
    getUsersLoading: state.user.getUsersLoading || null,
}),
    dispatch =>
    ({
        getUser: () => dispatch(getUser()),
        getAllProducts: () => dispatch(getAllProducts()),
        getNewToken: (payload_data) => dispatch(getNewToken(payload_data)),
        getSubscriptionInfo: () => dispatch(getSubscriptionInfo()),
    }))(UserSubscription);
